export default {
  UNAUTHENTICATED: true,
  FORBIDDEN: true
};

export const UNAUTHENTICATED = 'UNAUTHENTICATED';
export const FORBIDDEN = 'FORBIDDEN';